export default __webpack_public_path__ + "static/logo-archon-b4f86c3d85284676f689763ef14cef68.png";